import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AthletesRoutingModule } from './athletes-routing.module';
import { BootstrapAtheletesComponent } from './components/bootstrap-atheletes/bootstrap-atheletes.component';
import { MembersAthletesModule } from '../members/details-page/members-athletes/members-athletes.module';
import { CommonPageComponentsModule } from '../common-page-components/common-page-components.module';
import { ServicesModule } from 'world-archery-lib';
import { MatIconModule } from '@angular/material/icon';

@NgModule({
  declarations: [BootstrapAtheletesComponent],
  imports: [
    CommonModule,
    AthletesRoutingModule,
    MembersAthletesModule,
    CommonPageComponentsModule,
    ServicesModule,
    MatIconModule
  ]
})
export class AthletesModule { }
